import { useDispatch, useSelector } from 'react-redux';
import {
  setProviderProfileItemAction,
  updateProviderProfileItemStatusAction,
} from '../actions/providerProfilesAction';
import { IAppStore } from '../types/appStore';
import { IOffer } from '../types/quote/offer';

export default function useProviderProfilesStore() {
  const dispatch = useDispatch();

  const providerProfiles = useSelector(
    (store: IAppStore) => store.providerProfiles
  );

  const setProfileItem = (payload: { [id: string]: IOffer }) =>
    dispatch(setProviderProfileItemAction(payload));

  const updateStatus = (payload: { field: string; status: string }) =>
    dispatch(updateProviderProfileItemStatusAction(payload));

  return {
    providerProfiles,
    setProfileItem,
    updateStatus,
  };
}
